module.exports = __webpack_public_path__ + "static/media/home-white.a6cc0476.svg";